import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LoginService, Provider, ProviderTitle } from '@docpath/linces-angular-components/common';
import { DpLoginInfo, DpLoginModule } from '@docpath/webcomponents';
import { RoutingPath } from 'src/app/constants/routing-path';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  imports: [DpLoginModule]
})

export class LoginComponent implements OnInit {

  error!: string;
    errorParameters: Record<string, string> = {};
  hasError!: boolean;
  hasOtherLoginError!: boolean;
    loginInfo!: { username: string; password: string };
  pattern!: string;
  providersData: Provider[] = [];
  providersTitle: { [key: string]: string; } = {
    'okta': ProviderTitle.Okta
  };
  providers: string[] = [];

  private readonly loginService = inject(LoginService);
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle('Welcome');
    this.error = '';
    this.hasError = false;
    this.hasOtherLoginError = false;
    this.loginInfo = { username: '', password: '' };
    this.pattern = '^\\S.*$';
    this.getProviders();
  }

  doLogin(loginEvent: DpLoginInfo) {
    this.loginInfo.username = loginEvent.user;
    this.loginInfo.password = loginEvent.password;
    this.login();
  }

  getProviders() {
    this.loginService.getProviders({
      catchError: () => {
        this.providers = [];
      },
      suscribe: response => {
        this.providersData = response.result as unknown as Provider[];

        this.providers = [];
        this.providersData.forEach(provider => {
          if (this.providersTitle[provider.type]) {
            this.providers.push(this.providersTitle[provider.type]);
          }
        });
      }
    });
  }

  otherLoginMethod(method: string) {
    this.hasOtherLoginError = false;
    if (method === ProviderTitle.Okta) {
      this.loginWithOkta();
    }
  }

  loginWithOkta() {
    const oktaProvider = this.providersData.find(provider => provider.type === 'okta');

    if (oktaProvider) {
      this.loginService.getOktaToken({
        catchError: (statusCode, message) => {
          this.manageOktaError(message);
        },
        suscribe: () => {
          this.router.navigate([RoutingPath.PATH_HOME]);
        }
      }, oktaProvider, environment.context, environment.context);
    }
  }

  manageOktaError(message: string) {
    if (message !== '') {
      this.hasOtherLoginError = true;
      this.error = message;
    }
  }

  private login() {
    this.loginService.login({
      queryParameters: { username: this.loginInfo.username, pass: this.loginInfo.password },
            catchError: (statusCode, message, messageParameters) => this.processError(message, messageParameters),
      suscribe: () => {
        this.router.navigate([RoutingPath.PATH_HOME]);
      }
    });
  }

    processError(message: string, messageParameters?: Record<string, string>): void {
        this.hasError = true;
        this.error = message;
        this.errorParameters = messageParameters ?? {};
    }
}
